<template>
  <footer class="page-footer">
    <div class="page-footer__container page-footer__socials">
      <div class="page-footer__container-inner page-footer__socials-inner">
        <div class="w-socials align_center style_default">
          <div class="w-socials-list">
            <div class="w-socials-item facebook">
              <a class="w-socials-item-link" target="_blank" :href="socials.facebook">
                <span class="w-socials-item-link-hover"></span>
              </a>
              <div class="w-socials-item-popup">
                <span>Facebook</span>
              </div>
            </div>
            <div class="w-socials-item instagram">
              <a class="w-socials-item-link" target="_blank" :href="socials.instagram">
                <span class="w-socials-item-link-hover"></span>
              </a>
              <div class="w-socials-item-popup">
                <span>Instagram</span>
              </div>
            </div>
            <div class="w-socials-item youtube">
              <a class="w-socials-item-link" target="_blank" :href="socials.youtube">
                <span class="w-socials-item-link-hover"></span>
              </a>
              <div class="w-socials-item-popup">
                <span>YouTube</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-footer__container page-footer__main">
      <div class="page-footer__container-inner page-footer__main-inner">
        <button type="button" class="page-footer__up-btn" @click.prevent="onClickToTop">
          <i class="fa fa-angle-up"></i>
        </button>

        <template v-if="showOneAddress">
          <div class="page-footer__address-row _one">
            <div class="page-footer__address">
              <h4 class="page-footer__address-title">{{ $t("Адреса") }}</h4>
              <div class="page-footer__address-item">
                <a href="#" class="page-footer__address-link" @click.prevent="onOpenMap"
                  ><i class="fa fa-map-marker"></i>{{ currentRestaurant.address }}</a
                >
              </div>
            </div>

            <div class="page-footer__address">
              <h4 class="page-footer__address-title">{{ $t("Телефон") }}</h4>
              <div class="page-footer__address-item">
                <a :href="`tel:${currentRestaurant.phone}`" class="page-footer__address-link">{{
                  currentRestaurant.phone
                }}</a>
              </div>
            </div>

            <div class="page-footer__address">
              <h4 class="page-footer__address-title">{{ $t("Години роботи") }}</h4>

              <div class="page-footer__address-item" v-html="currentRestaurant.schedule" data-html/>
            </div>
          </div>
        </template>

        <template v-else>
          <h4 class="page-footer__title">{{ $t("Адреси у м.Ковель") }}</h4>

          <div class="page-footer__address-row">
            <div v-for="item in restaurants" :key="item.id" class="page-footer__address">
              <div v-if="item.address && item.title" class="page-footer__address-item">
                <a href="#" class="page-footer__address-link">{{ item.title }}</a>
                <p class="page-footer__address-link">{{ item.address }}</p>
              </div>

              <div v-if="item.phone" class="page-footer__address-item">
                <a :href="`tel:${item.phone}`" class="page-footer__address-link"
                  >{{ item.phone }}
                </a>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="page-footer__container page-footer__bottom">
      <div class="page-footer__container-inner page-footer__bottom-inner">
        <div>© {{ $t("Сім’я ресторанів «Classic». Всі права застережено!") }}&nbsp;</div>

        <nav class="page-footer__bottom-nav">
          <router-link :to="{name: 'privacy-policy'}">
            {{ $t('Політика конфіденційності') }}
          </router-link>
          <router-link :to="{name: 'public-offer'}">
            {{ $t('Договір публічної оферти') }}
          </router-link>
        </nav>

        <div class="page-footer__bottom-item">
          <a
            target="_blank"
            class="page-footer__bottom-item_developer"
            href="https://domino-it.agency/"
          >
            <p>{{ $t("Розроблено") }}</p>

            <BaseSvg name="ico-domino" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
import it from "vue2-datepicker/locale/es/it";

export default {
  name: "TheFooter",
  data() {
    return {};
  },
  computed: {
    it() {
      return it;
    },
    showOneAddress() {
      return (
        this.$route.name === "restaurant" ||
        this.$route.name === "restaurant-with-category" ||
        this.$route.name === "menu-with-category" ||
        this.$route.name === "menu"
      );
    },
    currentRestaurant() {
      return this.restaurants.find((item) => item.id === this.$route.params.id);
    },
    socials() {
      return this.$store.state.footerSocials;
    },
    ...mapState("restaurants", ["restaurants"]),
  },
  methods: {
    onClickToTop() {
      this.$scrollTo({ offset: 0 });
    },
    onOpenMap() {
      this.$vModal.open("map");
    },
  },
  watch: {
    $route() {
      this.$store.dispatch("footerSocials/setDefault");
    },
  },
};
</script>

<style></style>
